import moment from "moment";
import { fetchCustomerList } from "../../../slices/customer/customerlist/thunk";
import { getSearchedCustomer } from "../../../slices/customer/customerserach/thunk";
import { fetchCustomerEvents } from "../../../slices/customer/events/thunk";
import { fetchCustomer } from "../../../slices/customer/fetchcustomer/thunk";
import { fetchCustomerSummary } from "../../../slices/customer/simulate/thunk";
import { getAllReservation } from "../../../slices/reservations/thunk";
import { getAllStation } from "../../../slices/stations/thunk";
import { formatCellValue,formatDateForDisplay } from "../../Utils/UtilityFunctions";

export const getCustomerData = (id, simulateOrPreview, setLoading, stationPermission, reservationPermission, customerPermission, setRenderSimulate, dispatch) => {
    stationPermission && dispatch(getAllStation(setLoading));
    reservationPermission && dispatch(getAllReservation());
    customerPermission && dispatch(fetchCustomer(setLoading, id.original.CustomerId));
    customerPermission && dispatch(
        fetchCustomerSummary(id, setLoading, simulateOrPreview, setRenderSimulate)
    );
    customerPermission && dispatch(fetchCustomerEvents(id));
};

export const navigateToCreateCustomer = (navigate) => {
    navigate("/create-customer");
};

export const handleSearch = (dispatch, setLoading, value, option, setGetTable, setErrors, setErrorMessage, setErrorIcon, searchFields, setRenderSimulate, reservationPermission, stationPermission, customerPermission, setSearchExpanding) => {
    dispatch(getSearchedCustomer(setLoading, value, option,setGetTable, setErrorMessage, setErrorIcon,searchFields,false,stationPermission, reservationPermission, customerPermission, setRenderSimulate,setSearchExpanding));
    setErrors('')
};

export const handleClearSearch = (setGetTable,setErrors, setErrorMessage, setErrorIcon, searchFields,setSearchExpanding,setSearchFields, setValue, setOption) => {
    setOption(null);
    setValue('')
    setGetTable(false)
    setErrors('')
    setSearchExpanding(false);
    setErrorMessage('Search for customer using the parameters above.')
    setErrorIcon('ri-user-fill')
   
    const clearedSearchFields = searchFields.map(field => ({
        ...field,
        value: ''
    }));
    
    setSearchFields(clearedSearchFields);
};

export const handleSelectChange = (setSelectedValue, selectedOption) => {
    setSelectedValue(selectedOption)
}

export const attributeColumnData = () => {
    const attributeColumn = [
        {
            accessorKey: 'name',
            header: 'Name',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
            
        },
        {
            accessorKey: 'value',
            header: 'Value',
            Cell: ({ cell }) => formatCellValue(cell.getValue())
        }
    ]
    return attributeColumn
}

const formatEventType = (eventType = "") => {
  return eventType
    .replace(/^Event/, "") // remove "Event" prefix
    .replace(/([A-Z])/g, " $1") // add space before capitals
    .trim();
};

export const eventColumnData = () => {
    const eventColumn = [
        {
            accessorFn: (row) => `${row?.baseEvent?.actionEventId || '-'}`,
            header: "Session ID"
        },
        {
            accessorKey: "subscriptionId",
            header: "Subscription ID"
        },
        {
            accessorFn: (row) => `${row?.baseEvent?.customerId}`,
            header: "Customer ID"
        },
        {
            accessorFn: (row) => formatEventType(row?.baseEvent?.eventType),
            header: "Description",
        },
        {
            accessorFn: (row) => `${row?.baseEvent?.startTime}`,
            header: "Event Start Time",
            Cell: ({ cell }) => moment(cell.getValue()).format("DD MMM YYYY hh:mm:ss A"),
        },
    ]
    return eventColumn
}

export const validateField = (field, value, setErrors) => {
    let error = '';

    if (field === 'msisdn') {
        const msisdnRegex = /^[0-9]{0,12}$/;
        if (!msisdnRegex.test(value)) {
            error = 'MSISDN must be up to 12 numeric characters';
        }
    } else if (field === 'imsi') {
        const imsiRegex = /^[0-9]{0,15}$/;
        if (!imsiRegex.test(value)) {
            error = 'IMSI must be a numeric value with a maximum of 15 digits.';
        }
    } 
    // else if (field === 'accountNumber') {
    //     const accountNumberRegex = /^[a-zA-Z0-9]{0,10}$/;
    //     if (!accountNumberRegex.test(value)) {
    //         error = 'Account Number must be alphanumeric with a maximum of 10 characters.';
    //     }
    // }

    setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: error,
    }));

    return error === '';
};

export const handleInputChange = (field, value,setErrors,setValue) => {
    if (validateField(field, value,setErrors)) {
        setValue(value)
    }
};
